// Configuración de analytics leída del entorno (per-repo: ec-bo usa CRA, o sea
// process.env.REACT_APP_*; ec-portal usa import.meta.env).
import type { Environment } from "./types";
import { GetVersionCode } from "../utilities/getVersion.utility";

const rawEnv = (process.env.REACT_APP_ENV ?? "").toLowerCase();

export const isDev = process.env.NODE_ENV !== "production";

/**
 * `REACT_APP_ENV` vale test | uat | prod (ver el banner de ambiente en
 * pages/dashboard/Dashboard.tsx). En `npm start` no hay build, así que se
 * distingue "local" para no mezclar el desarrollo con las métricas reales.
 */
export const environment: Environment = isDev
  ? "local"
  : rawEnv === "prod"
  ? "prod"
  : rawEnv === "uat"
  ? "uat"
  : "test";

export const appVersion = GetVersionCode();

export const analyticsKey = process.env.REACT_APP_POSTHOG_KEY ?? "";

export const analyticsHost = process.env.REACT_APP_POSTHOG_HOST ?? "https://eu.i.posthog.com";

/** Kill switch. Lo usan los e2e de Playwright para no ensuciar las métricas. */
export const analyticsDisabled = process.env.REACT_APP_ANALYTICS_DISABLED === "true";
